import './App.css';
import { ReactComponent as Logo } from './ressources/ads_logo.svg';
import React, { useState, useEffect, useCallback } from 'react';
import Menu from './widgets/menu.js';
import Home from './pages/Home.js';
import Historique from './pages/Historique.js';
import Projets from './pages/Projets.js';
import Demarche from './pages/Demarche.js';

const VALID_PAGES = ['home', 'historique', 'projets', 'demarche'];

function readPageFromHash() {
  const h = window.location.hash.replace(/^#\/?/, '').split('?')[0];
  if (VALID_PAGES.includes(h)) return h;
  return 'home';
}

function App() {
  const [scrolled, setScrolled] = useState(false);
  const [page, setPage] = useState(readPageFromHash());

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const onHash = () => setPage(readPageFromHash());
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  const navigate = useCallback((target) => {
    if (!VALID_PAGES.includes(target)) target = 'home';
    if (target === 'home') {
      window.history.pushState(null, '', window.location.pathname + window.location.search);
    } else {
      window.location.hash = `/${target}`;
    }
    setPage(target);
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  return (
    <div className="app">
      <Menu scrolled={scrolled} navigate={navigate} currentPage={page} />

      {page === 'home' && <Home navigate={navigate} />}
      {page === 'historique' && <Historique navigate={navigate} />}
      {page === 'projets' && <Projets navigate={navigate} />}
      {page === 'demarche' && <Demarche navigate={navigate} />}

      <footer className="footer">
        <div className="footer-inner">
          <Logo className="footer-logo" />
          <p>&copy; {new Date().getFullYear()} Action Directe Sahel. Tous droits réservés.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
